import { AccessObjectTypeEnum, UserResource } from '@.api/methods';
import { StatisticObjectEnum } from '@/Services/StatisticPermissionService';
import { StoresDictionary } from '@/Types/api/Dictionaries';

import { UsersData } from './types';

export const mapUserResponseTypeToUserData = (userResponse: UserResource, stores: StoresDictionary[] = []): Partial<UsersData> => {
    const { name, role, status, company, email, username, statistic_object, access_object } = userResponse;

    const statisticObjectType = statistic_object?.type;
    const statisticObjectTypeId = statistic_object?.id;

    const accessObjectType = access_object?.type;
    const accessObjectTypeId = access_object?.id;

    const formUserData: Partial<UsersData> = {
        name,
        email,
        username,
        company_id: company?.id,
        role_id: role?.id,
        status: status?.id,
        statistic_object_type: statisticObjectType,
        statistic_object_type_id: statisticObjectTypeId,
        access_object_type: accessObjectType,
        access_object_type_id: accessObjectTypeId,
        sp_cluster_id: userResponse.sp_cluster?.id,
    };

    if (statisticObjectType === StatisticObjectEnum.STORE_GROUP) {
        formUserData.statistic_object_store_group_id = statisticObjectTypeId;
    } else if (statisticObjectType === StatisticObjectEnum.STORE) {
        const selectedStore = stores.find((store) => store.id === statisticObjectTypeId);

        formUserData.statistic_object_store_group_id = selectedStore?.store_group_id;
        formUserData.statistic_object_store_id = statisticObjectTypeId;
    }

    if (accessObjectType === AccessObjectTypeEnum.STORE_GROUP) {
        formUserData.access_object_store_group_id = accessObjectTypeId;
    } else if (accessObjectType === AccessObjectTypeEnum.STORE) {
        const selectedStore = stores.find((store) => store.id === accessObjectTypeId);

        formUserData.access_object_store_group_id = selectedStore?.store_group_id;
        formUserData.access_object_store_id = accessObjectTypeId;
    }

    return formUserData;
};
